export default "__VITE_ASSET__Cu7qB7sJ__"